import { atom } from 'jotai';
import type { Geometry, Polygon } from 'geojson';
import type { SurveyAreaCandidate } from 'components/query-map/map-pick-control';
import type { PickedSurveyArea } from 'components/query-map/map-workspace-state';
import type { DrawShape } from './create-area-types';
import type { HandlerRef } from './types';

/*
 * The Create New Area panel and the map it draws on are siblings on the catalog page
 * and live in different subtrees on Map Query, so the state between them lives here
 * rather than in whichever component happens to be their common parent.
 */
export const workspacePolygonsAtom = atom<Polygon[]>([]);
export const workspaceIsDrawingAtom = atom(false);
export const workspaceNeedsMapAtom = atom(false);
export const workspaceEditingIndexAtom = atom<number | null>(null);
/**
 * On to begin with, as the v8 mock has it: survey-aligned boundaries are the point of
 * drawing here, and off-by-default read as snapping being broken.
 */
export const workspaceSnapToGridAtom = atom(true);
export const workspacePreviewGeometryAtom = atom<Geometry | null>(null);
export const workspacePreviewColorAtom = atom<string | null>(null);
export const workspacePickedSurveyAreasAtom = atom<PickedSurveyArea[]>([]);
/** Which shape the drawn method puts down next: a traced polygon or a circle. */
export const workspaceDrawShapeAtom = atom<DrawShape>('polygon');

/*
 * Map-click handlers are held in a ref, not in atom state: as state they fed a
 * register-rebuild-register loop (see `useHandlerSlot`). A read-only atom gives each
 * store its own ref; the boolean beside it is what the map re-renders for.
 */
export const unitClickRefAtom = atom<HandlerRef<number>>(() => ({
  current: null,
}));
export const unitClickEnabledAtom = atom(false);
export const surveyPickRefAtom = atom<HandlerRef<SurveyAreaCandidate[]>>(
  () => ({ current: null })
);
export const surveyPickEnabledAtom = atom(false);
